// extracted by mini-css-extract-plugin
module.exports = {"comment":"comment_comment__K0bin","children":"comment_children__tlPfJ","meta":"comment_meta__Ulkq1","toggle":"comment_toggle__LC3uM","text":"comment_text__zoCgd"};